import './style.css';

class PCHighlightSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Any JavaScript needed for the highlight section can be initialized here
  }
}

customElements.define('pc-highlight-section', PCHighlightSection); 